/*
 * @Author       : Duanjiaojiao
 * @Date         : 2023-07-13 11:01:38
 * @LastEditors  : Duanjiaojiao
 * @LastEditTime : 2023-08-08 11:19:58
 * @Description  : 异常监控，发送至企微
 * @FilePath     : /BM-Main/src/utils/ErrorMonitor.js
 */
import httpClient from '@/utils/http'
import { zzHost } from '@/conf/hosts.conf'
import { getT } from '@/utils/judgeT';
import { url, cookie } from '@zz-common/zz-utils'

const API = {
  sendBusinessWechatMsg: `${zzHost}/zzopen/zzbmlogic/sendBusinessWechatMsg`
}

// 通知机器人
const notify = (params) => {
  const { sceneType, msgInfo } = params || {}
  return httpClient.post(API.sendBusinessWechatMsg, { sceneType, msgInfo }, { format: 'application/json' }).catch(e => {
    console.log('e: ', e);
  })
}

// LBS异常上报
export const LBSMonitor = (error) => {
  try {
    const { channel } = url.getParams() || {}
    const tk = cookie.get('tk')
    const ppu = cookie.get('PPU')
    const uid = cookie.get('uid')
    const {
      key,
      apiName,
      api,
      msg
    } = error || {}

    const content = `转转下单前上报：您使用的腾讯服务应用<font color="info">${key}</font>，<font color="warning">${apiName}</font><font color="comment">（${api}）</font>提示“<font color="warning">${msg}</font>”，t=${getT()}，channel=${channel}，url=${location.href}，tk=${tk}，ppu=${ppu}，uid=${uid}，请尽快联系合作商务或[在线申请额度](https://lbs.qq.com/dev/console/quotaImprove)`

    notify({
      msgInfo: {
        msgtype: 'markdown',
        markdown: {
          content
        }
      },
      sceneType: 'LBS_Service'
    })
  } catch (e) {
    console.log('e: ', e);
  }
}
